import { Component, OnInit } from '@angular/core';
import { Settings, AppSettings } from '../../app.settings';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-meta_atom',
  templateUrl: './meta_atom.component.html',
  styleUrls: ['./meta_atom.component.scss']
})
export class MetaAtomComponent implements OnInit {

  public bgImage;
  public settings: Settings;


  constructor(public appSettings:AppSettings, private viewportScroller: ViewportScroller) {
  }

  ngOnInit() {
    
  }

  ngOnDestroy(){    
    
  }

  public onClick(elementId: string): void { 
    this.viewportScroller.scrollToAnchor(elementId);
  }

}
